import React from 'react';
import './css/NavigationBar.css';
import { AiTwotoneGift } from 'react-icons/ai';
import { t } from 'ttag';
import { mixpanel } from './mp.js';


function NavigationBar({ handlesetIndex, index }) {

  const toggleMenuAct = (ind) => {
    if (ind === 0) { mixpanel.track('Home') }
    if (ind === 1) { mixpanel.track('Earn') }
    if (ind === 2) { mixpanel.track('Affiliate') }
    if (ind === 3) { mixpanel.track('Project') }
    if (ind === 6) { mixpanel.track('Card') }
    if (ind === 5) { mixpanel.track('Gift') }
    handlesetIndex(ind)
  }

  return (
    <div className="navigation-bar">
      <button className={index == 0 ? "nav-button-hover" : "nav-button"} onClick={() => toggleMenuAct(0)}>{t`Home`}</button>
      <button className={index == 1 ? "nav-button-hover" : "nav-button"} onClick={() => toggleMenuAct(1)}>{t`Earn`}</button>
      <button className={index == 5 ? "nav-button-hover-akc" : "nav-button-akc"} onClick={() => toggleMenuAct(5)}><AiTwotoneGift /></button>
      <button className={index == 2 ? "nav-button-hover" : "nav-button"} onClick={() => toggleMenuAct(2)}>{t`Affiliate`}</button>
      <button className={index == 6 ? "nav-button-hover" : "nav-button"} onClick={() => toggleMenuAct(6)}>{t`Partners`}</button>
    </div>
  );
}

export { NavigationBar };